import slice from "./profitSlice";

export default slice.reducer;
